import {Button, ButtonProps, ButtonTypeMap} from '@mui/material';
import {forwardRef} from 'react';
import {Translation} from '../../i18n/Translation';
import {NamespacePrefixedKey} from '#common/i18n/types';

export type TextButtonProps<
  RootComponent extends React.ElementType = ButtonTypeMap['defaultComponent'],
  AdditionalProps = unknown,
> = Omit<ButtonProps<RootComponent, AdditionalProps>, 'aria-label' | 'data-translate'> & {
  i18nKey: NamespacePrefixedKey;
};

export const TextButton = forwardRef<HTMLButtonElement, TextButtonProps>(({i18nKey, ...muiProps}, ref) => {
  return (
    <Translation keys={i18nKey}>
      {(text) => (
        <Button {...muiProps} aria-label={text} ref={ref}>
          {text}
        </Button>
      )}
    </Translation>
  );
});

TextButton.displayName = 'TextButton';
